import React, { useContext, useEffect, useState } from 'react';
import {
  BdsGrid,
  BdsPaper,
  BdsTypo,
  BdsTable,
  BdsTableHeader,
  BdsTableBody,
  BdsTableCell,
  BdsTableRow,
  BdsTableTh,
  BdsButtonIcon,
} from 'blip-ds/dist/blip-ds-react';
import MtlsContext from '../../../../contexts/MtlsContext';
import { MtlsCertificate } from '../../../../models/MtlsCertificate';
import { BlipLoadingComponent } from '../../../../components/BlipLoading/BlipLoadingComponent';
import { useContentLocalizer } from '../../../../hooks/useContentLocalizer';
import { localization } from './localization';
import RemoveHost from '../RemoveHost';

interface MtlsHostHeader {
  url: string;
  actions: string;
}

const ListHosts: React.FC = () => {
  const { mtlsCertificate, openRemoveHostAlert, certificateUpdatedProps, setCertificateUpdatedProps } =
    useContext(MtlsContext);
  const [isLoading, setLoading] = useState(false);
  const [certificate, setCertificate] = useState<MtlsCertificate | null>(null);
  const content = useContentLocalizer(localization);

  const heading: MtlsHostHeader[] = [content.host, content.actions];

  const handleDeleteHostAlert = (hostId: string) => {
    openRemoveHostAlert(hostId);
    setCertificateUpdatedProps({ ...certificateUpdatedProps, hostId: hostId });
  };

  useEffect(() => {
    try {
      setLoading(true);
      if (!mtlsCertificate) return;
      const currentCertificate = mtlsCertificate?.filter((item) => {
        return item.certificate_id == certificateUpdatedProps.certificateId;
      });
      setCertificate(currentCertificate[0] || null);
      setCertificateUpdatedProps({ ...certificateUpdatedProps, hostUpdated: false });
    } finally {
      setLoading(false);
    }
  }, [certificateUpdatedProps.certificateId, certificateUpdatedProps.hostUpdated]);

  return (
    <>
      <BdsPaper>
        <BdsGrid padding="3">
          <BdsGrid xxs="12" direction="column">
            <BdsGrid margin="b-2" direction="column">
              <BdsTypo variant="fs-20" margin={false} style={{ maxWidth: '40rem' }}>
                {content.formatString(content.title, certificate ? certificate?.description : '')}
              </BdsTypo>
            </BdsGrid>
            {isLoading ? (
              <BlipLoadingComponent align="center" />
            ) : (
              <BdsTable
                id="hosts-table"
                style={{
                  maxWidth: '40rem',
                  maxHeight: '20rem',
                  overflowY: 'scroll',
                }}
              >
                <BdsTableHeader>
                  <BdsTableRow>
                    {heading.map((item, index) => {
                      return <BdsTableTh key={index}>{item}</BdsTableTh>;
                    })}
                  </BdsTableRow>
                </BdsTableHeader>
                <BdsTableBody>
                  {certificate?.hosts?.map((row, index) => {
                    return (
                      <BdsTableRow key={index} data-testid={row.host_id}>
                        <BdsTableCell style={{ minWidth: '20rem' }}>
                          <BdsTypo variant="fs-14">{row.host}</BdsTypo>
                        </BdsTableCell>
                        <BdsTableCell type="custom" style={{ maxWidth: '5rem' }}>
                          <BdsButtonIcon
                            onClick={() => {
                              handleDeleteHostAlert(row.host_id);
                            }}
                            size="short"
                            variant="secondary"
                            icon="trash"
                          ></BdsButtonIcon>
                        </BdsTableCell>
                      </BdsTableRow>
                    );
                  })}
                </BdsTableBody>
              </BdsTable>
            )}
          </BdsGrid>
        </BdsGrid>
      </BdsPaper>
      <RemoveHost />
    </>
  );
};

export default ListHosts;
